import { NgModule } from '@angular/core';
import { SharedModule } from '@biletix/shared/shared.module';
import { ArtistService} from './services/artist-service';
import { MatMenuModule } from '@angular/material/menu';
import { ArtistEventListComponent } from './artist-event-list/artist-event-list.component';
import { ArtistRoutingModule } from './artist-routing.module';
import { ArtistListItemComponent } from './artist-event-list/Component/artist-list-item.component';
import { ArtistPastPerformancesComponent } from './artist-past-performances/artist-past-performances.component';
import { DatePipe } from '@angular/common';
import { ArtistPageComponent } from './components/artist-page.component';

@NgModule({
  declarations: [
    ArtistEventListComponent,
    ArtistPageComponent,
    ArtistListItemComponent,
    ArtistPastPerformancesComponent
  ],
  imports: [
    SharedModule, 
    ArtistRoutingModule, 
    MatMenuModule
  ],
  providers: [
    ArtistService,
    DatePipe
  ],
  exports: [
    ArtistPastPerformancesComponent
  ]
})
export class ArtistModule {}
